import { Box, FormControl, FormLabel, RadioGroup } from "@mui/material";
import trans from "helpers/trans";
import { FC } from "react";
import { useBasket } from "../basketContext";
import CheckboxTicket from "./CheckboxTicket";
import RadioTicket from "./RadioTicket";

type TicketsProps = {};

const Tickets: FC<TicketsProps> = () => {
    const { event, tickets } = useBasket();

    const renderTickets = () => {
        if (!event) return null;

        if (event.ticket_multiselection) {
            return event.event_tickets.map((ticket) => (
                <CheckboxTicket
                    key={ticket.id}
                    ticket={ticket}
                    quantity={
                        tickets.find((t) => t.id === ticket.id)?.quantity || 0
                    }
                />
            ));
        }

        return (
            <RadioGroup sx={{ gap: 2 }}>
                {event.event_tickets.map((ticket) => {
                    const isChecked = tickets[0]?.id === ticket.id;
                    return (
                        <RadioTicket
                            key={ticket.id}
                            ticket={ticket}
                            isChecked={isChecked}
                        />
                    );
                })}
            </RadioGroup>
        );
    };

    return (
        <FormControl sx={{ width: "100%" }}>
            <FormLabel
                sx={{
                    fontFamily: "'Lato', sans-serif",
                    fontSize: { xs: 16, tablet: 18 },
                    fontWeight: 700,
                    textAlign: "left",
                    color: { xs: "#495366", tablet: "#02263A" },
                    mr: 0,
                    pb: 1,
                    "&.Mui-focused": { color: "black" },
                }}
            >
                {trans(`event.webEvent.modal.ticketModal.title.chooseType`)}
            </FormLabel>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                }}
            >
                {renderTickets()}
            </Box>
        </FormControl>
    );
};

export default Tickets;
